module.exports = __webpack_public_path__ + "static/img/news.4c650a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/news.jpg
// module id = W4eC
// module chunks = 5